webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"","app":"","absolute":"","clipped-left":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.signedIn)?_c('v-toolbar-title',[_c('span',{staticClass:"green-dot"}),_vm._v(" "+_vm._s(_vm.onlineUserCount)+" "),_c('v-icon',[_vm._v("people")])],1):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Chat__ = __webpack_require__(118);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/chat',
    name: 'Chat',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Chat__["a" /* default */]
  }]
}));

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec33980a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(116);
var normalizeComponent = __webpack_require__(35)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec33980a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"text-xs-center":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-around":"","align-center":""}},[_c('v-flex',{attrs:{"align-center":"","align-content-center":"","justify-center":""}},[_c('img',{attrs:{"src":__webpack_require__(117)}}),_vm._v(" "),_c('h1',[_vm._v("The Best Omegle Alternative")]),_vm._v(" "),_c('p',[_vm._v("Instant cam to cam chat with random strangers around the world")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-carousel',{staticClass:"elevation-0",staticStyle:{"max-width":"400px","height":"90px","display":"inline-block"},attrs:{"hide-controls":"","hide-delimiters":""}},[_c('v-carousel-item',[_c('h2',[_vm._v("⚡ Lightning Fast")]),_vm._v(" "),_c('p',[_vm._v("Lightweight interface and ultra-fast backend.")])]),_vm._v(" "),_c('v-carousel-item',[_c('h2',[_vm._v("💰 Completely Free")]),_vm._v(" "),_c('p',[_vm._v("Free to use, for everyone, forever.")])]),_vm._v(" "),_c('v-carousel-item',[_c('h2',[_vm._v("🕶️ Anonymous")]),_vm._v(" "),_c('p',[_vm._v("No registration required.")])]),_vm._v(" "),_c('v-carousel-item',[_c('h2',[_vm._v("🛡️ Secure")]),_vm._v(" "),_c('p',[_vm._v("Encrypted connexion, we don't keep any log.")])]),_vm._v(" "),_c('v-carousel-item',[_c('h2',[_vm._v("📱 Optimized for mobile")]),_vm._v(" "),_c('p',[_vm._v("Progessive Web App that works on all your devices.")])])],1),_vm._v(" "),_c('h2',[_vm._v("Click START and say Hi! 😄")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","router":"","to":"/chat","color":"success"},on:{"click":_vm.next}},[_vm._v("Start")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ddb6548_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__(154);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(35)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ddb6548_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 119:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('v-layout',{attrs:{"column":_vm.$vuetify.breakpoint.xs,"fill-height":""}},[_c('v-layout',{attrs:{"column":"","justify-end":"","fill-height":""}},[_c('div',{staticStyle:{"position":"relative","flex-grow":"1","overflow":"hidden","background-color":"#2c204d"}},[_c('div',{staticStyle:{"position":"absolute","top":"0","left":"0","right":"0","bottom":"0","overflow":"hidden"}},[_c('video',{attrs:{"id":"remoteVideo","autoplay":"","playsinline":""}})]),_vm._v(" "),(_vm.remoteStream === null)?_c('v-icon',{staticStyle:{"position":"absolute","right":"50%","bottom":"50%","transform":"translate(50%,50%)","font-size":"35vw","opacity":"0.25"},attrs:{"color":"white"}},[_vm._v("account_circle")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","bottom":"10px","left":"10px","width":"20%","height":"20%"}},[_c('video',{attrs:{"id":"localVideo","autoplay":"","playsinline":"","muted":""},domProps:{"muted":true}}),_vm._v(" "),_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":"canvas"}})])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-toolbar',{attrs:{"prominent":!_vm.$vuetify.breakpoint.xs,"flat":""}},[_c('v-spacer'),_vm._v(" "),(_vm.signedIn && (_vm.waitingForPeer || _vm.isChatReady))?_c('v-btn',{attrs:{"flat":"","large":"","color":"success"},on:{"click":_vm.pause}},[_c('v-icon',[_vm._v("pause")]),_vm._v(" Stop")],1):_vm._e(),_vm._v(" "),(_vm.signedIn && !_vm.waitingForPeer && !_vm.isChatReady)?_c('v-btn',{attrs:{"flat":"","large":"","color":"success"},on:{"click":_vm.next}},[_c('v-icon',[_vm._v("play_arrow")]),_vm._v(" Start")],1):_vm._e(),_vm._v(" "),(_vm.signedIn && !_vm.waitingForPeer && _vm.isChatReady)?_c('v-btn',{attrs:{"flat":"","large":"","color":"success"},on:{"click":_vm.next}},[_c('v-icon',[_vm._v("skip_next")]),_vm._v(" Next")],1):_vm._e(),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),(!_vm.$vuetify.breakpoint.xs)?_c('v-divider',{attrs:{"vertical":""}}):_vm._e(),_vm._v(" "),(_vm.$vuetify.breakpoint.xs)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-end":"","fill-height":""}},[_c('div',{staticClass:"content-wrapper chat-background",staticStyle:{"flex-grow":"1"}},[_c('div',{staticClass:"content-scroll",attrs:{"id":"chat-content-scroll","data-simplebar":"","data-simplebar-auto-hide":"false"}},[_c('div',_vm._l((_vm.roomMessages),function(i){return _c('v-layout',{key:("" + (i.messageId)),attrs:{"row":"","pl-4":"","pr-4":""}},[(i.userId !== _vm.userId)?_c('div',{staticClass:"remote-chat-message"},[_vm._v("\n                "+_vm._s(i.text)+"\n              ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(i.userId === _vm.userId)?_c('div',{staticClass:"local-chat-message"},[_vm._v("\n                "+_vm._s(i.text)+"\n              ")]):_vm._e()],1)}))]),_vm._v(" "),(_vm.signedIn && !_vm.waitingForPeer && !_vm.isChatReady)?_c('div',{staticClass:"text-xs-center",staticStyle:{"position":"absolute","right":"50%","bottom":"50%","transform":"translate(50%,50%)","opacity":"0.25"}},[_c('h2',[_vm._v("Click START when you are ready")])]):_vm._e(),_vm._v(" "),(_vm.waitingForPeer)?_c('div',{staticClass:"text-xs-center",staticStyle:{"position":"absolute","right":"50%","bottom":"50%","transform":"translate(50%,50%)","opacity":"0.25"}},[_c('v-progress-circular',{staticStyle:{"margin":"20px"},attrs:{"indeterminate":"","size":70,"width":7,"color":"primary"}}),_vm._v(" "),_c('h2',[_vm._v("Looking for someone you can chat with...")])],1):_vm._e()]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-toolbar',{attrs:{"id":"chat-input-box","prominent":"","flat":""}},[_c('v-text-field',{staticStyle:{"position":"absolute","top":"7px","left":"7px","right":"7px","bottom":"7px"},attrs:{"solo":"","label":"Message","append-icon":"send","disabled":!_vm.isChatReady},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitInput()},"click:append":function($event){_vm.submitInput()}},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__waitingQueue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__room__ = __webpack_require__(192);










__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  modules: {
    waitingQueue: __WEBPACK_IMPORTED_MODULE_7__waitingQueue__["a" /* default */],
    room: __WEBPACK_IMPORTED_MODULE_8__room__["a" /* default */]
  },
  state: {
    isStandalone: false,
    userId: null,
    status: 'offline',
    signedIn: false,
    onlineUserCount: 0
  },
  mutations: {
    setIsStandalone: function setIsStandalone(state, _ref) {
      var isStandalone = _ref.isStandalone;

      state.isStandalone = isStandalone;
    },
    setUserId: function setUserId(state, _ref2) {
      var userId = _ref2.userId;

      state.userId = userId;
    },
    setStatus: function setStatus(state, _ref3) {
      var status = _ref3.status;

      state.status = status;
    },
    setSignedIn: function setSignedIn(state, _ref4) {
      var signedIn = _ref4.signedIn;

      state.signedIn = signedIn;
    },
    setOnlineUserCount: function setOnlineUserCount(state, _ref5) {
      var onlineUserCount = _ref5.onlineUserCount;

      state.onlineUserCount = onlineUserCount;
    }
  },
  actions: {
    signUp: function signUp() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5_firebase_app__["auth"]().signInAnonymously();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    logout: function logout(_ref6) {
      var _this2 = this;

      var dispatch = _ref6.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch('pause');

              case 2:
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_firebase_app__["auth"]().signOut();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    next: function next(_ref7) {
      var _this3 = this;

      var dispatch = _ref7.dispatch,
          state = _ref7.state;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var leaveRoomAsync;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (state.signedIn) {
                  _context3.next = 3;
                  break;
                }

                global.DEBUG && console.log('not signed in');
                return _context3.abrupt('return');

              case 3:
                leaveRoomAsync = null;

                if (state.room.roomId !== null) {
                  leaveRoomAsync = dispatch('room/leave', { isInitiator: true });
                }

                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([leaveRoomAsync, dispatch('waitingQueue/start', {
                  userId: state.userId,
                  onPeerFound: function onPeerFound(_ref8) {
                    var remoteId = _ref8.remoteId;

                    global.DEBUG && console.log('peer found: ' + remoteId);
                    dispatch('room/create', {
                      localId: state.userId,
                      remoteId: remoteId,
                      onRoomTerminatedByPeer: function onRoomTerminatedByPeer() {
                        dispatch('next');
                      }
                    });
                  }
                })]);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleInvitation: function handleInvitation(_ref9, invitation) {
      var _this4 = this;

      var dispatch = _ref9.dispatch,
          state = _ref9.state;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (state.signedIn) {
                  _context4.next = 3;
                  break;
                }

                global.DEBUG && console.log('not signed in');
                return _context4.abrupt('return');

              case 3:
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch('waitingQueue/stop'), dispatch('room/join', {
                  localId: state.userId,
                  invitation: invitation,
                  onRoomTerminatedByPeer: function onRoomTerminatedByPeer() {
                    dispatch('next');
                  }
                })]);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    pause: function pause(_ref10) {
      var _this5 = this;

      var dispatch = _ref10.dispatch,
          state = _ref10.state;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (state.signedIn) {
                  _context5.next = 3;
                  break;
                }

                global.DEBUG && console.log('not signed in');
                return _context5.abrupt('return');

              case 3:
                if (!state.waitingQueue.isWaiting) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 6;
                return dispatch('waitingQueue/stop');

              case 6:
                if (!(state.room.roomId !== null)) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 9;
                return dispatch('room/leave', { isInitiator: true });

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  getters: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__database__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__database__);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    userId: null,
    isWaiting: false,
    onPeerFound: null,
    waitingQueueChangedHandlerRef: null
  },

  mutations: {
    setUserId: function setUserId(state, _ref) {
      var userId = _ref.userId;

      global.DEBUG && console.log('setUserId: ' + userId);
      state.userId = userId;
    },
    setIsWaiting: function setIsWaiting(state, _ref2) {
      var isWaiting = _ref2.isWaiting;

      state.isWaiting = isWaiting;
    },
    setOnPeerFound: function setOnPeerFound(state, _ref3) {
      var onPeerFound = _ref3.onPeerFound;

      state.onPeerFound = onPeerFound;
    },
    setWaitingQueueChangedHandlerRef: function setWaitingQueueChangedHandlerRef(state, _ref4) {
      var waitingQueueChangedHandlerRef = _ref4.waitingQueueChangedHandlerRef;

      state.waitingQueueChangedHandlerRef = waitingQueueChangedHandlerRef;
    }
  },

  actions: {
    start: function start(_ref5, _ref6) {
      var _this = this;

      var state = _ref5.state,
          commit = _ref5.commit,
          dispatch = _ref5.dispatch;
      var userId = _ref6.userId,
          onPeerFound = _ref6.onPeerFound;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var waitingQueueChangedHandlerRef;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                global.DEBUG && console.log('start waiting');
                commit('setUserId', { userId: userId });
                commit('setOnPeerFound', { onPeerFound: onPeerFound });

                // start listending for changes in the waiting queue
                waitingQueueChangedHandlerRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"]().ref(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USERS"]).orderByValue().on('value', function (snapshot) {
                  dispatch('waitingQueueChangedHandler', { waitingQueue: snapshot.val() });
                });

                commit('setWaitingQueueChangedHandlerRef', { waitingQueueChangedHandlerRef: waitingQueueChangedHandlerRef });

                // Enter the waiting queue
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USER"], state.userId)).set(__WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"].ServerValue.TIMESTAMP);

              case 7:
                commit('setIsWaiting', { isWaiting: true });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stop: function stop(_ref7) {
      var _this2 = this;

      var state = _ref7.state,
          commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(state.isWaiting === false)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:

                global.DEBUG && console.log('stop waiting');

                // stop listending for changes in the waiting queue
                __WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"]().ref(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USERS"]).orderByValue().off('value', state.waitingQueueChangedHandlerRef);
                commit('setWaitingQueueChangedHandlerRef', { waitingQueueChangedHandlerRef: null });

                // Leave the waiting queue
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USER"], state.userId)).remove();

              case 7:
                commit('setIsWaiting', { isWaiting: false });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    waitingQueueChangedHandler: function waitingQueueChangedHandler(_ref8, _ref9) {
      var _this3 = this;

      var state = _ref8.state,
          commit = _ref8.commit;
      var waitingQueue = _ref9.waitingQueue;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var sortedList, sortedListLenght, i, item, remoteId, updates;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(waitingQueue === null)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:

                global.DEBUG && console.log('waiting queue:');
                sortedList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(waitingQueue).sort(function (a, b) {
                  return a[1] - b[1];
                });
                sortedListLenght = sortedList.length;
                i = 0;

              case 6:
                if (!(i < sortedListLenght)) {
                  _context3.next = 25;
                  break;
                }

                item = sortedList[i];

                global.DEBUG && console.log('  index=' + i + ', key=' + item[0] + ', value=' + item[1]);

                if (!(item[0] === state.userId && i > 0)) {
                  _context3.next = 22;
                  break;
                }

                // If we found ourselves in the list...
                // stop listending for changes in the waiting queue
                __WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"]().ref(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USERS"]).orderByValue().off('value', state.waitingQueueChangedHandlerRef);
                commit('setWaitingQueueChangedHandlerRef', { waitingQueueChangedHandlerRef: null });

                if (!(i % 2 === 1)) {
                  _context3.next = 21;
                  break;
                }

                remoteId = sortedList[i - 1][0];

                // Remove the two users from the waiting queue

                updates = {};

                updates[String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USER"], state.userId)] = null;
                updates[String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WAITING_USER"], remoteId)] = null;
                _context3.next = 19;
                return __WEBPACK_IMPORTED_MODULE_3_firebase_app__["database"]().ref().update(updates);

              case 19:
                commit('setIsWaiting', { isWaiting: false });

                // Notify the parent object
                if (state.onPeerFound !== null) {
                  state.onPeerFound({ remoteId: remoteId });
                }

              case 21:
                return _context3.abrupt('return');

              case 22:
                i++;
                _context3.next = 6;
                break;

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chat__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__database__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__database__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(208);












/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  modules: {
    chat: __WEBPACK_IMPORTED_MODULE_6__chat__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_7__video__["a" /* default */]
  },
  state: {
    localId: null,
    remoteId: null,
    roomId: null,
    roomEmptyHandlerRef: null,
    onRoomTerminatedByPeer: null,
    startTime: new Date()
  },
  mutations: {
    setLocalId: function setLocalId(state, _ref) {
      var localId = _ref.localId;

      global.DEBUG && console.log('setLocalId: ' + localId);
      state.localId = localId;
    },
    setRemoteId: function setRemoteId(state, _ref2) {
      var remoteId = _ref2.remoteId;

      global.DEBUG && console.log('setRemoteId: ' + remoteId);
      state.remoteId = remoteId;
    },
    setRoomId: function setRoomId(state, _ref3) {
      var roomId = _ref3.roomId;

      global.DEBUG && console.log('setRoomId: ' + roomId);
      state.roomId = roomId;
    },
    setRoomEmptyHandlerRef: function setRoomEmptyHandlerRef(state, _ref4) {
      var roomEmptyHandlerRef = _ref4.roomEmptyHandlerRef;

      global.DEBUG && console.log('setRoomEmptyHandlerRef: ' + roomEmptyHandlerRef);
      state.roomEmptyHandlerRef = roomEmptyHandlerRef;
    },
    setOnRoomTerminatedByPeer: function setOnRoomTerminatedByPeer(state, _ref5) {
      var onRoomTerminatedByPeer = _ref5.onRoomTerminatedByPeer;

      state.onRoomTerminatedByPeer = onRoomTerminatedByPeer;
    },
    setStartTime: function setStartTime(state, _ref6) {
      var startTime = _ref6.startTime;

      global.DEBUG && console.log('setStartTime: ' + startTime);
      state.startTime = startTime;
    }
  },
  actions: {
    create: function create(_ref7, _ref8) {
      var _this = this;

      var dispatch = _ref7.dispatch,
          commit = _ref7.commit,
          state = _ref7.state;
      var localId = _ref8.localId,
          remoteId = _ref8.remoteId,
          onRoomTerminatedByPeer = _ref8.onRoomTerminatedByPeer;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var roomId, tmpRef, roomEmptyHandlerRef;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('setLocalId', { localId: localId });

                // Leave the current room if needed

                if (!(state.roomId !== null)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return dispatch('leave', { isInitiator: true });

              case 4:

                // Create a new room
                roomId = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(__WEBPACK_IMPORTED_MODULE_8__database__["ROOMS"]).push().key;

                global.DEBUG && console.log('creating room ' + roomId);
                tmpRef = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["ROOM_USER"], roomId, localId));
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([tmpRef.set(__WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"].ServerValue.TIMESTAMP), dispatch('chat/start', { localId: localId, remoteId: remoteId, roomId: roomId }), dispatch('video/start', { localId: localId, remoteId: remoteId, roomId: roomId, sendOffer: false })]);

              case 9:
                tmpRef.onDisconnect().remove();
                commit('setRoomId', { roomId: roomId });
                commit('setRemoteId', { remoteId: remoteId });

                // Listen for empty room
                commit('setOnRoomTerminatedByPeer', { onRoomTerminatedByPeer: onRoomTerminatedByPeer });
                roomEmptyHandlerRef = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["ROOM_USERS"], roomId)).on('child_removed', function () {
                  dispatch('leave', { isInitiator: false });
                  if (onRoomTerminatedByPeer) {
                    onRoomTerminatedByPeer();
                  }
                });

                commit('setRoomEmptyHandlerRef', { roomEmptyHandlerRef: roomEmptyHandlerRef });

                // Invite the other user to join the room
                _context.next = 17;
                return dispatch('invite', { remoteId: remoteId });

              case 17:
                commit('setStartTime', { startTime: new Date() });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    invite: function invite(_ref9, _ref10) {
      var _this2 = this;

      var state = _ref9.state;
      var remoteId = _ref10.remoteId;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var invitationId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                global.DEBUG && console.log('inviting ' + remoteId + ' to join the room');
                invitationId = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["INVITATIONS"], remoteId)).push().key;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["INVITATION"], remoteId, invitationId)).set({ senderId: state.localId, roomId: state.roomId });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    join: function join(_ref11, _ref12) {
      var _this3 = this;

      var dispatch = _ref11.dispatch,
          commit = _ref11.commit,
          state = _ref11.state;
      var localId = _ref12.localId,
          invitation = _ref12.invitation,
          onRoomTerminatedByPeer = _ref12.onRoomTerminatedByPeer;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var roomEmptyHandlerRef, tmpRef;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                global.DEBUG && console.log('joining room ' + invitation.roomId);
                commit('setLocalId', { localId: localId });

                // Leave the current room if needed

                if (!(state.roomId !== null)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return dispatch('leave', { isInitiator: true });

              case 5:

                // Listen for empty room
                commit('setOnRoomTerminatedByPeer', { onRoomTerminatedByPeer: onRoomTerminatedByPeer });
                roomEmptyHandlerRef = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["ROOM_USERS"], invitation.roomId)).on('child_removed', function () {
                  dispatch('leave', { isInitiator: false });
                  if (onRoomTerminatedByPeer) {
                    onRoomTerminatedByPeer();
                  }
                });

                commit('setRoomEmptyHandlerRef', { roomEmptyHandlerRef: roomEmptyHandlerRef });

                // Join the room
                tmpRef = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["ROOM_USER"], invitation.roomId, localId));
                _context3.next = 11;
                return tmpRef.set(__WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"].ServerValue.TIMESTAMP);

              case 11:
                tmpRef.onDisconnect().remove();
                commit('setRoomId', { roomId: invitation.roomId });
                commit('setRemoteId', { remoteId: invitation.senderId });

                // Start the chat and the video
                _context3.next = 16;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([dispatch('chat/start', { localId: localId, remoteId: state.remoteId, roomId: invitation.roomId }), dispatch('video/start', { localId: localId, remoteId: state.remoteId, roomId: invitation.roomId, sendOffer: true })]);

              case 16:
                commit('setStartTime', { startTime: new Date() });

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    leave: function leave(_ref13, _ref14) {
      var _this4 = this;

      var state = _ref13.state,
          commit = _ref13.commit,
          dispatch = _ref13.dispatch;
      var isInitiator = _ref14.isInitiator;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _event;

        var duration;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(state.roomId === null)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:

                global.DEBUG && console.log('leaving room ' + state.roomId);

                // Report to Google Analytics
                duration = Math.round((new Date() - state.startTime) / 1000);

                Object(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__["event"])((_event = {
                  eventCategory: 'Room',
                  eventAction: 'Exit',
                  eventValue: isInitiator ? 1 : 0
                }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* CUSTOM_METRIC_ID_ROOM_DURATION */], duration), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* CUSTOM_METRIC_ID_CHAT_MESSAGE_COUNT */], state.chat.messages.length), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, __WEBPACK_IMPORTED_MODULE_10__constants__["d" /* CUSTOM_METRIC_ID_VIDEO_CONNEXION_SUCCESSFUL */], state.video.connectionSuccessful ? 1 : 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* CUSTOM_METRIC_ID_VIDEO_CONNEXION_RELAYED */], state.video.connectionRelayed ? 1 : 0), _event));

                // Stop listening for an empty room
                __WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["ROOM_USERS"], state.roomId)).off('child_removed', state.roomEmptyHandlerRef);
                commit('setRoomEmptyHandlerRef', { roomEmptyHandlerRef: null });

                // Leave the room
                _context4.next = 9;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_8__database__["ROOM_USER"], state.roomId, state.localId)).remove(), dispatch('chat/stop'), dispatch('video/stop')]);

              case 9:
                commit('setRoomId', { roomId: null });
                commit('setRemoteId', { remoteId: null });

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__database__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__database__);






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    localId: null,
    remoteId: null,
    roomId: null,
    messageHandlerRef: null,
    isReady: false,
    messages: []
  },

  mutations: {
    setEndPoints: function setEndPoints(state, _ref) {
      var localId = _ref.localId,
          remoteId = _ref.remoteId;

      state.localId = localId;
      state.remoteId = remoteId;
    },
    setRoomId: function setRoomId(state, _ref2) {
      var roomId = _ref2.roomId;

      state.roomId = roomId;
    },
    setMessageHandlerRef: function setMessageHandlerRef(state, _ref3) {
      var handlerRef = _ref3.handlerRef;

      state.messageHandlerRef = handlerRef;
    },
    setIsReady: function setIsReady(state, _ref4) {
      var isReady = _ref4.isReady;

      state.isReady = isReady;
    },
    clearMessages: function clearMessages(state) {
      global.DEBUG && console.log('clear messages');
      state.messages = [];
    },
    addMessage: function addMessage(state, _ref5) {
      var messageId = _ref5.messageId,
          userId = _ref5.userId,
          text = _ref5.text;

      global.DEBUG && console.log('add message: ' + text);
      state.messages.push({ messageId: messageId, userId: userId, text: text });
    }
  },

  actions: {
    start: function start(_ref6, _ref7) {
      var commit = _ref6.commit,
          state = _ref6.state;
      var localId = _ref7.localId,
          remoteId = _ref7.remoteId,
          roomId = _ref7.roomId;

      global.DEBUG && console.log('chat started');
      commit('setEndPoints', { localId: localId, remoteId: remoteId });
      commit('setRoomId', { roomId: roomId });
      var messageHandlerRef = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_4__database__["CHAT_ROOM"], state.roomId)).on('child_added', function (data) {
        commit('addMessage', { messageId: data.key, userId: data.val().userId, text: data.val().text });
      });
      commit('setMessageHandlerRef', { messageHandlerRef: messageHandlerRef });
      commit('setIsReady', { isReady: true });
    },
    stop: function stop(_ref8) {
      var _this = this;

      var state = _ref8.state,
          commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (state.isReady) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                global.DEBUG && console.log('chat stopped');
                commit('setIsReady', { isReady: false });
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_4__database__["CHAT_ROOM"], state.roomId)).off('child_added', state.messageHandlerRef);

              case 6:
                commit('setMessageHandlerRef', { messageHandlerRef: null });
                commit('clearMessages');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    say: function say(_ref9, _ref10) {
      var _this2 = this;

      var state = _ref9.state;
      var text = _ref10.text;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var messageId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                global.DEBUG && console.log('sending message: ' + text);
                messageId = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_4__database__["CHAT_ROOM"], state.roomId)).push().key;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_4__database__["CHAT_ROOM_MESSAGE"], state.roomId, messageId)).set({
                  timestamp: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"].ServerValue.TIMESTAMP,
                  userId: state.localId,
                  text: text
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_storage__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__database__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__database__);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    localId: null,
    remoteId: null,
    roomId: null,
    peerConnection: null,
    messageHandlerRef: null,
    localStream: null,
    remoteStream: null,
    iceConnectionState: null,
    connectionSuccessful: false,
    connectionRelayed: false
  },

  mutations: {
    reset: function reset(state) {
      state.localId = null;
      state.remoteId = null;
      state.roomId = null;
      if (state.peerConnection !== null) {
        state.peerConnection.close();
        state.peerConnection.onicecandidate = null;
        state.peerConnection.onaddstream = null;
        state.peerConnection.oniceconnectionstatechange = null;
        state.peerConnection = null;
        state.messageHandlerRef = null;
      }
      // state.localStream = null // We keep it for the next time
      // document.getElementById('localVideo').srcObject = null // We keep it for the next time
      state.remoteStream = null;
      document.getElementById('remoteVideo').srcObject = null;
      state.iceConnectionState = null;
      state.connectionSuccessful = false;
      state.connectionRelayed = false;
    },
    setEndPoints: function setEndPoints(state, _ref) {
      var localId = _ref.localId,
          remoteId = _ref.remoteId;

      state.localId = localId;
      state.remoteId = remoteId;
    },
    setRoomId: function setRoomId(state, _ref2) {
      var roomId = _ref2.roomId;

      state.roomId = roomId;
    },
    setPeerConnection: function setPeerConnection(state, _ref3) {
      var peerConnection = _ref3.peerConnection;

      state.peerConnection = peerConnection;
    },
    setOnIceCandidateHandler: function setOnIceCandidateHandler(state, _ref4) {
      var handler = _ref4.handler;

      state.peerConnection.onicecandidate = handler;
    },
    setOnAddStreamHandler: function setOnAddStreamHandler(state, _ref5) {
      var handler = _ref5.handler;

      state.peerConnection.onaddstream = handler;
    },
    setOnIceConnectionStateChange: function setOnIceConnectionStateChange(state, _ref6) {
      var handler = _ref6.handler;

      state.peerConnection.oniceconnectionstatechange = handler;
    },
    setMessageHandlerRef: function setMessageHandlerRef(state, _ref7) {
      var handlerRef = _ref7.handlerRef;

      state.messageHandlerRef = handlerRef;
    },
    setLocalStream: function setLocalStream(state, _ref8) {
      var stream = _ref8.stream;

      state.localStream = stream;
      document.getElementById('localVideo').srcObject = stream;
    },
    setRemoteStream: function setRemoteStream(state, _ref9) {
      var stream = _ref9.stream;

      state.remoteStream = stream;
      document.getElementById('remoteVideo').srcObject = stream;
    },
    setIceConnectionState: function setIceConnectionState(state, _ref10) {
      var iceConnectionState = _ref10.iceConnectionState;

      state.iceConnectionState = iceConnectionState;
      if (iceConnectionState === 'connected') {
        state.connectionSuccessful = true;
      }
    },
    setConnectionSuccessful: function setConnectionSuccessful(state, _ref11) {
      var connectionSuccessful = _ref11.connectionSuccessful;

      state.connectionSuccessful = connectionSuccessful;
    },
    setConnectionRelayed: function setConnectionRelayed(state, _ref12) {
      var connectionRelayed = _ref12.connectionRelayed;

      state.connectionRelayed = connectionRelayed;
    }
  },

  actions: {
    start: function start(_ref13, _ref14) {
      var state = _ref13.state,
          commit = _ref13.commit,
          dispatch = _ref13.dispatch;
      var localId = _ref14.localId,
          remoteId = _ref14.remoteId,
          roomId = _ref14.roomId,
          sendOffer = _ref14.sendOffer;

      global.DEBUG && console.log('video started');
      commit('setPeerConnection', {
        peerConnection: new RTCPeerConnection({ 'iceServers': [{ 'urls': 'stun:stun.services.mozilla.com' }, { 'urls': 'stun:stun.l.google.com:19302' }, { 'urls': 'turn:numb.viagenie.ca', 'credential': 'JFV6mDOmmv7Mv9KC195D', 'username': 'gregory.journe@nurgo-software.com' }] })
      });
      return dispatch('initializeLocalStream').then(function () {
        commit('setEndPoints', { localId: localId, remoteId: remoteId });
        commit('setRoomId', { roomId: roomId });
        commit('setOnIceCandidateHandler', {
          handler: function handler(event) {
            return event.candidate ? dispatch('sendWebRtcMessage', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ ice: event.candidate })) : global.DEBUG && console.log('Sent All Ice');
          }
        });
        commit('setOnAddStreamHandler', {
          handler: function handler(event) {
            return commit('setRemoteStream', { stream: event.stream });
          }
        });
        commit('setOnIceConnectionStateChange', {
          handler: function handler() {
            commit('setIceConnectionState', { iceConnectionState: state.peerConnection.iceConnectionState });
            state.peerConnection.getStats().then(function (stats) {
              var selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(stats.values())).find(function (s) {
                return s.type === 'candidate-pair' && s.selected;
              });
              if (!selected) {
                return;
              }
              var candidate = stats.get(selected.localCandidateId);
              if (candidate.candidateType === 'relayed') {
                commit('setConnectionRelayed', { connectionRelayed: true });
              }
            });
          }
        });
        var messageHandlerRef = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WEBRTC_ROOM_USER"], roomId, localId)).on('child_added', function (message) {
          dispatch('handleWebRtcMessage', message.val());
        });
        commit('setMessageHandlerRef', { messageHandlerRef: messageHandlerRef });
        if (sendOffer) {
          state.peerConnection.createOffer().then(function (offer) {
            return state.peerConnection.setLocalDescription(offer);
          }).then(function () {
            dispatch('sendWebRtcMessage', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ sdp: state.peerConnection.localDescription }));
          });
        }
      });
    },
    stop: function stop(_ref15) {
      var state = _ref15.state,
          commit = _ref15.commit;

      global.DEBUG && console.log('video stopped');
      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WEBRTC_ROOM_USER"], state.roomId, state.localId)).off('child_added', state.messageHandlerRef);
      commit('reset');
    },
    initializeLocalStream: function initializeLocalStream(_ref16) {
      var state = _ref16.state,
          commit = _ref16.commit;

      if (state.localStream === null) {
        return navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function (stream) {
          commit('setLocalStream', { stream: stream });
          state.peerConnection.addStream(stream);
        });
      }
      state.peerConnection.addStream(state.localStream);
      return null;
    },
    sendWebRtcMessage: function sendWebRtcMessage(_ref17, message) {
      var state = _ref17.state;

      return __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_5__database__["WEBRTC_ROOM_USER"], state.roomId, state.remoteId)).push(message);
    },
    handleWebRtcMessage: function handleWebRtcMessage(_ref18, message) {
      var state = _ref18.state,
          dispatch = _ref18.dispatch;

      global.DEBUG && console.log('handleWebRtcMessage: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(message));
      var msg = JSON.parse(message);
      if (msg.ice !== undefined) {
        state.peerConnection.addIceCandidate(new RTCIceCandidate(msg.ice));
      } else if (msg.sdp.type === 'offer') {
        state.peerConnection.setRemoteDescription(new RTCSessionDescription(msg.sdp)).then(function () {
          return state.peerConnection.createAnswer();
        }).then(function (answer) {
          return state.peerConnection.setLocalDescription(answer);
        }).then(function () {
          return dispatch('sendWebRtcMessage', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'sdp': state.peerConnection.localDescription }));
        });
      } else if (msg.sdp.type === 'answer') {
        state.peerConnection.setRemoteDescription(new RTCSessionDescription(msg.sdp));
      }
    },
    updateLocalSnapshot: function updateLocalSnapshot(_ref19, _ref20) {
      var state = _ref19.state;
      var blob = _ref20.blob;

      if (!state.localStream) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_2_firebase_app__["storage"]().ref('preview/' + state.localId).put(blob);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

var LIVE = 'live';
var SESSIONS = LIVE + '/sessions';
var SESSION = SESSIONS + '/{0}';
var SESSION_DATA = LIVE + '/sessionData/{0}';
var WAITING_USERS = LIVE + '/waitingUsers';
var WAITING_USER = WAITING_USERS + '/{0}';
var INVITATIONS = SESSION_DATA + '/invitations';
var INVITATION = INVITATIONS + '/{1}';
var ROOMS = LIVE + '/rooms';
var ROOM = ROOMS + '/{0}';
var ROOM_USERS = ROOMS + '/{0}/users';
var ROOM_USER = ROOM_USERS + '/{1}';
var ROOM_DATA = LIVE + '/roomData/{0}';
var CHAT_ROOM = ROOM_DATA + '/chat';
var CHAT_ROOM_MESSAGE = CHAT_ROOM + '/{1}';
var WEBRTC_ROOM = ROOM_DATA + '/webRtc';
var WEBRTC_ROOM_USER = WEBRTC_ROOM + '/{1}';
var WEBRTC_ROOM_USER_MESSAGE = WEBRTC_ROOM_USER + '/{2}';

module.exports.LIVE = LIVE;
module.exports.SESSIONS = SESSIONS;
module.exports.SESSION = SESSION;
module.exports.SESSION_DATA = SESSION_DATA;
module.exports.WAITING_USERS = WAITING_USERS;
module.exports.WAITING_USER = WAITING_USER;
module.exports.INVITATIONS = INVITATIONS;
module.exports.INVITATION = INVITATION;
module.exports.ROOMS = ROOMS;
module.exports.ROOM = ROOM;
module.exports.ROOM_USERS = ROOM_USERS;
module.exports.ROOM_USER = ROOM_USER;
module.exports.ROOM_DATA = ROOM_DATA;
module.exports.CHAT_ROOM = CHAT_ROOM;
module.exports.CHAT_ROOM_MESSAGE = CHAT_ROOM_MESSAGE;
module.exports.WEBRTC_ROOM = WEBRTC_ROOM;
module.exports.WEBRTC_ROOM_USER = WEBRTC_ROOM_USER;
module.exports.WEBRTC_ROOM_USER_MESSAGE = WEBRTC_ROOM_USER_MESSAGE;

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOM_METRIC_ID_ROOM_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_METRIC_ID_CHAT_MESSAGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CUSTOM_METRIC_ID_VIDEO_CONNEXION_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CUSTOM_METRIC_ID_VIDEO_CONNEXION_RELAYED; });
var CUSTOM_METRIC_ID_ROOM_DURATION = 'metric1';
var CUSTOM_METRIC_ID_CHAT_MESSAGE_COUNT = 'metric2';
var CUSTOM_METRIC_ID_VIDEO_CONNEXION_SUCCESSFUL = 'metric3';
var CUSTOM_METRIC_ID_VIDEO_CONNEXION_RELAYED = 'metric4';

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false,
      items: [{
        icon: 'home',
        title: 'Menu not yet implemented'
      }],
      title: 'BlaBla.Cam'
    };
  },


  name: 'App',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['signedIn', 'onlineUserCount']))
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['next']))
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simplebar__ = __webpack_require__(69);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      input: '',
      chatScrollBar: null
    };
  },


  mounted: function mounted() {
    this.chatScrollBar = new __WEBPACK_IMPORTED_MODULE_2_simplebar__["a" /* default */](document.getElementById('chat-content-scroll'), { autoHide: false });
  },

  watch: {
    'roomMessages': function roomMessages(val, oldVal) {
      var _this = this;

      this.$nextTick(function () {
        _this.chatScrollBar.getScrollElement().scrollTop = _this.chatScrollBar.getScrollElement().scrollHeight;
      });
    },
    'videoLocalStream': function videoLocalStream(val, oldVal) {
      var _this2 = this;

      if (val && !oldVal) {
        setTimeout(function () {
          return _this2.captureSnapshot();
        }, 1000);
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    roomMessages: function roomMessages() {
      return this.$store.state.room.chat.messages;
    },
    videoLocalStream: function videoLocalStream() {
      return this.$store.state.room.video.localStream;
    },
    videoRemoteStream: function videoRemoteStream() {
      return this.$store.state.room.video.remoteStream;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['userId', 'signedIn']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    roomId: function roomId(state) {
      return state.room.roomId;
    },
    waitingForPeer: function waitingForPeer(state) {
      return state.waitingQueue.isWaiting;
    },
    isChatReady: function isChatReady(state) {
      return state.room.chat.isReady;
    },
    remoteStream: function remoteStream(state) {
      return state.room.video.remoteStream;
    }
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['signUp', 'logout', 'next', 'pause']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('room/chat', ['say']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('room/video', ['updateLocalSnapshot']), {
    submitInput: function submitInput() {
      if (this.input !== '' && this.input.length <= 150) {
        this.say({ text: this.input });
        this.input = '';
      }
    },
    captureSnapshot: function captureSnapshot() {
      var _this3 = this;

      var video = document.getElementById('localVideo');
      var canvas = document.getElementById('canvas');
      var width = 320;
      var height = width * video.videoHeight / video.videoWidth;
      canvas.setAttribute('width', width);
      canvas.setAttribute('height', height);
      canvas.getContext('2d').drawImage(video, 0, 0, width, height);
      canvas.toBlob(function (blob) {
        _this3.updateLocalSnapshot({ blob: blob });
      }, 'image/jpeg', 0.75);
    }
  })
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_database__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_simplebar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_simplebar_dist_simplebar_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_simplebar_dist_simplebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_simplebar_dist_simplebar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__database__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__database__);














global.DEBUG = "production" !== 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: '#6b4fbb',
    // secondary: '#000000'
    accent: '#fc6d26'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
  id: 'UA-2807532-24',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    exception: true,
    exceptionLogs: global.DEBUG
  },
  batch: {
    enabled: true,
    amount: 10,
    delay: 2000 // milliseconds
  },
  debug: {
    enabled: global.DEBUG
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

if (!String.format) {
  String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  };
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  created: function created() {
    var _this = this;

    if (window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches) {
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].commit('setIsStandalone', { isStandalone: true });
    }

    if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].state.isStandalone) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({ path: 'chat' });
    }

    __WEBPACK_IMPORTED_MODULE_7_firebase_app__["initializeApp"]({
      apiKey: 'AIzaSyAWVQZYgVbAvWA1-IZu0jRRSl5nrXT1tzI',
      authDomain: 'random-video-chat-34e27.firebaseapp.com',
      databaseURL: 'https://random-video-chat-34e27.firebaseio.com',
      projectId: 'random-video-chat-34e27',
      storageBucket: 'random-video-chat-34e27.appspot.com',
      messagingSenderId: '62391710558'
    });

    if (global.DEBUG) {
      console.log('DB.SESSIONS: ' + __WEBPACK_IMPORTED_MODULE_12__database__["SESSIONS"]);
      console.log('DB.SESSION: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["SESSION"], 'userId1'));

      console.log('DB.WAITING_USERS: ' + __WEBPACK_IMPORTED_MODULE_12__database__["WAITING_USERS"]);
      console.log('DB.WAITING_USER: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["WAITING_USER"], 'userId1'));

      console.log('DB.INVITATIONS: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["INVITATIONS"], 'userId1'));
      console.log('DB.INVITATION: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["INVITATION"], 'userId1', 'invitation1'));

      console.log('DB.ROOMS: ' + __WEBPACK_IMPORTED_MODULE_12__database__["ROOMS"]);
      console.log('DB.ROOM: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["ROOM"], 'roomId1'));
      console.log('DB.ROOM_USERS: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["ROOM_USERS"], 'roomId1'));
      console.log('DB.ROOM_USER: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["ROOM_USER"], 'roomId1', 'userId1'));

      console.log('DB.CHAT_ROOM: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["CHAT_ROOM"], 'roomId1'));
      console.log('DB.CHAT_ROOM_MESSAGE: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["CHAT_ROOM_MESSAGE"], 'roomId1', 'msgId1'));

      console.log('DB.WEBRTC_ROOM: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["WEBRTC_ROOM"], 'roomId1'));
      console.log('DB.WEBRTC_ROOM_USER: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["WEBRTC_ROOM_USER"], 'roomId1', 'userId1'));
      console.log('DB.WEBRTC_ROOM_USER_MESSAGE: ' + String.format(__WEBPACK_IMPORTED_MODULE_12__database__["WEBRTC_ROOM_USER_MESSAGE"], 'roomId1', 'userId1', 'msgId1'));
    }

    __WEBPACK_IMPORTED_MODULE_7_firebase_app__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        if (!user.isAnonymous) {
          _this.$ga.set({ userId: user.uid });
        }
        var connectedUsersRef = __WEBPACK_IMPORTED_MODULE_7_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_12__database__["SESSION"], user.uid));
        connectedUsersRef.onDisconnect().remove();
        connectedUsersRef.set(__WEBPACK_IMPORTED_MODULE_7_firebase_app__["database"].ServerValue.TIMESTAMP).then(function () {
          global.DEBUG && console.log('signed int');
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].commit('setUserId', { userId: user.uid });
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].commit('setSignedIn', { signedIn: true });
          __WEBPACK_IMPORTED_MODULE_7_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_12__database__["INVITATIONS"], user.uid)).on('child_added', function (snapshot) {
            var invitation = snapshot.val();
            if (invitation !== null) {
              __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].dispatch('handleInvitation', invitation);
            }
          });
          __WEBPACK_IMPORTED_MODULE_7_firebase_app__["database"]().ref('Stats/SessionCount/current').on('value', function (snapshot) {
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].commit('setOnlineUserCount', { onlineUserCount: snapshot.val() + 810 });
          });
        });
      } else if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].state.userId !== null) {
        global.DEBUG && console.log('logged out');
        __WEBPACK_IMPORTED_MODULE_7_firebase_app__["database"]().ref(String.format(__WEBPACK_IMPORTED_MODULE_12__database__["SESSION"], __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].state.userId)).set(null);
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].commit('setSignedIn', { signedIn: false });
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].commit('setUserId', { userId: null });
      }
    });

    // Automatically signup anonymously
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].dispatch('signUp');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f40a416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(112);
function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var normalizeComponent = __webpack_require__(35)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f40a416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[97]);


// WEBPACK FOOTER //
// static/js/app.6695cf1bf0043a3cff13.js